import { createContext, useContext } from 'react'

import { SequenceDocumentationRender } from './bpmn-diagram.types'

export const SequenceDocumentationContext = createContext<SequenceDocumentationRender | null>(null)

export function useSequenceDocumentation(): SequenceDocumentationRender | null {
  return useContext(SequenceDocumentationContext)
}
